/* Бутон за пускане и пауза на зацикленото видео.
   Ако системата е настроена на по-малко движение, видеото
   не тръгва само — показва се първият кадър и бутон за пускане. */
(function () {
  'use strict';


  /* Голям бутон за пускане върху видеото. Изчезва, щом тръгне. */
  function initPlay(root) {
    var btns = (root || document).querySelectorAll('[data-lp-play]');
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.dataset.lpPlayOn === '1') return;
      btn.dataset.lpPlayOn = '1';

      var box = btn.parentNode;
      var vid = box.querySelector('video');
      if (!vid) return;

      function paint() { box.classList.toggle('is-playing', !vid.paused); }

      btn.addEventListener('click', function () {
        // Спираме всички други видеа, за да не звучат едновременно.
        Array.prototype.forEach.call(document.querySelectorAll('video'), function (o) {
          if (o !== vid) o.pause();
        });
        vid.play();
      });

      vid.addEventListener('play', paint);
      vid.addEventListener('pause', paint);
      paint();
    });
  }

  function init(root) {
    var stages = (root || document).querySelectorAll('[data-lp-video]');
    Array.prototype.forEach.call(stages, function (stage) {
      if (stage.dataset.lpVideoOn === '1') return;
      stage.dataset.lpVideoOn = '1';

      var video  = stage.querySelector('video');
      var toggle = stage.querySelector('[data-lp-video-toggle]');
      if (!video || !toggle) return;

      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (calm) {
        video.removeAttribute('autoplay');
        video.pause();
      }

      function paint() {
        var playing = !video.paused;
        stage.classList.toggle('is-paused', !playing);
        toggle.setAttribute('aria-label', playing ? toggle.dataset.pause : toggle.dataset.play);
      }

      toggle.addEventListener('click', function () {
        if (video.paused) { video.play(); } else { video.pause(); }
        paint();
      });

      video.addEventListener('play', paint);
      video.addEventListener('pause', paint);
      paint();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initPlay(); });
  } else {
    init(); initPlay();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initPlay(e.target); });
})();
